import React from 'react'
import { useLocation } from 'react-router-dom'
import './footer.scss'

const Footer = () => {
  const { pathname } = useLocation()

  const isBigFooter = ['/accueil', '/'].includes(pathname)

  return <div className={`footer ${isBigFooter ? 'big' : ''}`}></div>
}

export default Footer
